<template>
  <div class="container doc">
    <h1>愛接送 預約式通用無障礙計程車 隱私權保護政策</h1>
    <br />
    <section>
      <h3>隱私權保護政策的內容</h3>
      <p>
        愛接送
        預約式通用(無障礙)計程車平台(以下簡稱愛接送平台)非常重視您的隱私權。請您閱讀以下有關隱私權保護政策的更多內容。
      </p>
    </section>
    <section>
      <h3>愛接送平台使用您個人資料的方式</h3>
      <p>
        本政策涵蓋的內容包括：愛接送平台如何處理蒐集或收到的個人資料
        (包括與您過去使用
        愛接送平台產品及服務相關的資料）。個人資料係指得以識別您的身分且未公開的資料，如姓名、地址、電子郵件地址、電話號碼或身障資格等。
        本隱私權保護政策只適用於 愛接送平台。
      </p>
    </section>
    <section>
      <h3>資料蒐集及使用</h3>
      <p>
        在您註冊 愛接送平台帳號、使用 愛接送平台產品或服務、瀏覽
        愛接送平台網頁或某些合作夥伴的網頁，以及參加宣傳活動或贈獎遊戲時，愛接送平台會蒐集您的個人資料。愛接送平台也可能將合作夥伴所提供的關於您的資訊與
        愛接送平台所擁有的您的個人資料相結合。
      </p>
      <p>
        當您在
        愛接送平台註冊乘客會員時，我們會詢問您的姓名、性別、身份證字號等資料。若您為使用愛接送司機提供服務的會員時，我們可能還會詢問您的所屬車隊、住址、車牌號碼等相關資料。在您註冊
        愛接送平台帳號並登入我們的服務後，我們就能辨別您的身分。您得自由選擇是否提供個人資料給我們，但當特定資料欄位係屬必填欄位者，您若不提供該等資料則無法使用相關的愛接送平台產品及服務。
      </p>
      <p>
        愛接送平台得於營運期間及經營地區內，於與客戶管理、會員管理、個人資料之交易、統計調查分析等之合理相關連之特定目的內，蒐集、處理及利用包括但不限於會員之姓名、電話、位置及乘車紀錄等基本資料及使用會員之個人資料，提供會員各種優惠措施及活動訊息，但會員如表示不同意或要求停止對其進行行銷，愛接送平台不得拒絕，且會員之權益不會受到影響。
      </p>
      <p>
        會員應確保提供之個人資料均屬真實，如個人資料誤填或有變更時，會員應隨時向愛接送平台更正或更新。如會員未及時更新，表示同意愛接送平台繼續依原登錄資料提供各項服務，且不會與愛接送平台對此產生爭議。若會員登錄不實資料，於會員活動所得之相關贈品時，該會員不得請求參與活動或兌換該贈品。
      </p>
      <p>
        會員活動所得之相關贈品內容，將不定期更新，會員不得要求兌換現金，兌換贈品如由各合作特約商直接提供予會員，其寄送、使用、保證、瑕疵擔保等問題，均由各合作特約商或活動主辦單位負責。除另有約定外，愛接送平台與各合作特約商間並無合夥、經銷、代理或保證人關係。如兌換贈品依法應繳納稅捐時，會員應自行負擔該筆稅款；如依相關稅法規定應預先代扣稅款或所兌贈品應併入個人所得時，其相關作業均由各合作特約商處理。愛接送平台網站提供之贈品兌換及活動內容，得依網站活動專區所述或以等值商品來兌換為主。
      </p>
      <p>
        為維護會員權益，如系統產生異常情況時，愛接送平台將暫停會員操作之登錄及相關功能；異常狀況解除時，愛接送平台將隨即恢復會員登錄及相關功能。
      </p>
      <p>
        愛接送平台保有會員申請、停用、修改或終止各項優惠服務之權利。有關會員之告知事項、服務辦法、相關權益及使用說明、標識符號、合作特約商、活動內容詳見平台網站。
      </p>
      <p>
        愛接送平台將不定期更新或變更相關資料，相關資訊以更新後者為準，如您繼續使用本會員之服務，將視為您同意更新之服務條款。如有任何問題，請來信hantek-iot@hantek.com.tw或透過<a
          href=" https://lin.ee/qq7E0q1"
          >Line@官方帳號</a
        >洽詢。
      </p>
      <p>
        上述內容有全部或一部份無效時，不影響其他約定之效力。服務辦法以中華民國法令為準據法並以台北地方法院為管轄法院。
      </p>
    </section>
    <section>
      <p>
        愛接送平台為提供會員服務並保護消費者權益，乃建立會員機制，以提供完整之會員服務，謹依個人資料保護法第8條規定向當事人蒐集個人資料時，應明確告知當事人下列事項：
      </p>
      <ul>
        <li>一、蒐集之目的。</li>
        <li>二、個人資料之類別。</li>
        <li>三、個人資料利用之期間、地區、對象及方式。</li>
        <li>四、當事人依第三條規定得行使之權利及方式。</li>
        <li>五、當事人得自由選擇提供個人資料時，不提供將對其權益之影響。</li>
      </ul>
      <p>
        自您加入成為會員（以下簡稱會員）即日起至愛接送平台及合作特約商終止營運之日、及會員停止提供服務之日止。
      </p>
    </section>
    <section>
      <h3>利用地區、對象及方式</h3>
      <ul>
        <li>
          (1)台灣地區及服務使用地，且基於履行契約義務，將提供相關資料予合作特約商或愛接送平台於特定目的範圍內委外之廠商。
        </li>
        <li>(2)愛接送平台將於蒐集之特定目的範圍內處理並利用個人資料。</li>
        <li>
          (3)合作特約廠商及委外廠商於贈品兌換及行銷等特定目的範圍內蒐集、處理或利用個人資料。
        </li>
      </ul>
      <p>會員就其個人資料依法得向愛接送平台以書面請求行使下開權利：</p>
      <ul>
        <li>a. 查詢或請求閱覽</li>
        <li>b. 補充或更正</li>
        <li>c. 請求停止蒐集、處理或利用</li>
        <li>d. 請求刪除</li>
      </ul>
      <p>
        上述權利，若因會員不符合申請程序或法律規定，或愛接送平台依法負有保存義務，或法律另有規定之情況者，不在此限。若您就您的會員註冊資料向愛接送平台請求答覆查詢、提供閱覽。
        消費者得自由選擇提供個人資料，惟若其提供之資料不足或有誤時，愛接送平台除將無法提供完整之服務將可能損及消費者之權益。
      </p>
    </section>
    <section>
      <h3>壹、平台會員資料</h3>
      <h4>一、關於平台會員註冊</h4>
      <p>
        您已充分瞭解愛接送平台會員服務條款，並已填寫會員申請資料至註冊頁面。您確認於註冊時提供個人資料均屬真實，如您個人資料誤填或有變更時，您將隨時更正或更新，如您未及時更新，表示您同意愛接送平台繼續依您原登錄資料提供各項服務。
      </p>
      <p>
        若您登錄不實或不完整資料，愛接送平台將暫停或終止您的會員資格，並拒絕您使用會員服務。
      </p>
      <p>
        如果您發現或合理懷疑有第三人使用您的會員資料，您應該立即通知愛接送平台，愛接送平台將採取必要的防範措施。
      </p>

      <h4>二、平台會員帳號、密碼及安全</h4>
      <p>
        註冊平台會員資料時，您必須提供一組個人辨識密碼。請您務必詳實填寫手機號碼及密碼，不可重複登錄。
      </p>
      <p>
        您應妥善保管帳號及密碼，並於每次連線完畢時或使用後確實登出，以防他人盜用。利用此組帳號與密碼登入系統後所進行之一切活動，您將負完全的責任。請勿將您的帳號與密碼洩露或提供予第三人知悉，以免因此遭人非法使用。以同一個會員手機號碼和密碼使用會員服務所進行的所有行為，都將被認為是這位會員本人的行為。
      </p>

      <h4>三、關於會員提供資訊</h4>
      <p>
        請您確認上載、傳送、輸入或提供至愛接送平台會員網站的資料，都已合法取得授權使用（下稱授權使用，包含但不限修改、重製、公開播送、改作、散佈、發行、公開發表等方式），並可將前述權利轉授權第三人。任何資料一經您上載、傳送、輸入或提供至愛接送平台時，視為您已同意愛接送平台取得您的授權使用，並得將前述權利轉授權他人，您對此絕無異議。您並應保證愛接送平台取得授權使用的內容，均無侵害任何第三人智慧財產權的情形，如果因此造成對愛接送平台的損失或損害，您承諾將對愛接送平台負賠償或補償責任。
      </p>

      <h4>四、父母或監護人義務</h4>
      <p>
        如您是未滿十二歲的兒童，請確認您的家長或監護人已同意您上網使用愛接送平台網站並且全程在旁陪伴；如您是十二歲以上未滿十八歲的青少年，當您上網前，請您確認您的家長或監護人已經同意您上網使用本服務。
      </p>

      <h4>五、資料記錄</h4>
      <p>
        當您使用愛接送平台網站時，在使用過程中所有的資料紀錄，均將會員服務資料庫所保存，您同意愛接送平台僅能於合理範圍內使用、分析；此外，如有任何糾紛，您同意以會員服務資料庫所記錄之電子資料為認定標準。
      </p>
      <p>
        如您登錄資料或您的行為與上述「會員資料」內容不符或有違反，您同意並瞭解愛接送平台將依此約定條款揭示內容處理，且表示您將自行負擔所有不便及相關法律責任。
      </p>

      <h4>六、取用、異動與刪除會員資料</h4>
      <p>
        若您為資料當事人，可以請求查詢、閱覽本人的個人資料或要求給予複本。
      </p>
      <p>
        若您的個人資料有變更、或發現您的個人資料不正確，可以向愛接送平台要求修改或更正；如您所提供之資料錯誤或缺漏，則不受本隱私權聲明之保護。
      </p>
      <p>
        當蒐集個人資料之目的消失或期限屆滿時，您可要求刪除、停止處理或利用個人資料。但因愛接送平台執行職務或業務所必須者，不在此限。
      </p>
      <p>
        因應歐盟個人資料保護法規（European Union General Data Protection
        Regulation, GDPR），歐盟國家使用者將暫停使用愛接送平台之各服務。
      </p>
      <p> 若您有任何詢問，請與愛接送平台之客服中心聯絡。 </p>
    </section>
    <h3>貳、會員服務</h3>
    <section>
      <h4>一、個人資料保護</h4>
      <p>
        關於您的會員註冊以及其他個人資料，都將受到愛接送平台「隱私權保護政策」的保護與規範。對於會員所登錄或留存之個人資料，愛接送平台都應予保護，但有下列情形時，不在此限：
      </p>
      <ul>
        <li>
          1.基於法律之規定、或受司法機關與其他有權機關基於法定程序之要求。
        </li>
        <li>2.在緊急情況下為維護其他會員或第三人之合法權益。</li>
        <li>3.您的行為違反會員約定條款。</li>
        <li>4.您的會員資料遭受他人冒用。</li>
        <li>5.為維護會員服務系統的正常運作。</li>
      </ul>

      <h4>二、智慧財產權</h4>
      <p>
        愛接送平台所使用之軟體或程式、網站上所有內容，包括但不限於著作、圖片、檔案、資訊、資料、網站架構、網站畫面的安排、網頁設計，均由愛接送平台或其他權利人依法擁有其智慧財產權；請務必於取得愛接送平台及其他權利人書面同意後，才能使用前述資料。
      </p>

      <h4>三、服務暫停與中斷</h4>
      <p>
        本系統或功能可能因『例行性』之維護、改置或變動發生服務暫停或中斷，愛接送平台將於該暫停或中斷前以電子郵件、公告或其他適當之方式告知會員。
      </p>
      <p>
        愛接送平台將以合理之方式及技術，維護會員服務之正常運作。但如有下列任一情況，愛接送平台將逕行暫停或中斷會員服務之全部或一部，且對因此所造成任何不便或損害，均不負任何賠償或補償之責任。
      </p>

      <h4>四、網站連結</h4>
      <p>
        為方便您自行蒐集或取得資訊，愛接送平台會員網站將提供其他網站連結，但此連結並不代表愛接送平台與此類連結網站管理者有任何合夥、僱傭或其他類似關係，其他業者經營的網站均由各該業者自行負責，愛接送平台對任何的外部連結，不擔保其合適性、有效性、或即時性，且愛接送平台不對連結網站所提供產品、服務或資訊提供擔保或其他責任。
      </p>

      <h4>五、會員服務管理</h4>
      <p>
        如您的會員資料遭受他人冒用、有違反交易安全、愛接送平台會員服務辦法約定條款等情形時，愛接送平台基於維護交易安全之考量，將事先通知會員，並終止會員帳號或服務之使用，必要時並將會員註冊資料會員服務移除或刪除，並對您此種不當使用請求賠償或補償責任。
      </p>
      <p>
        愛接送平台可能因網站管理或其他因素，變更或終止部份或全部會員服務或活動，此類變更或終止均將貼示在愛接送平台網站相關網頁或以其他方式通知。
        可藉由網站服務通知愛接送平台變更會員服務內容或終止會員服務，請注意愛接送平台均將在您接獲電子郵件並回覆確認次日起，對您的會員服務進行變更或終止；在此提醒，此類變更或終止，可能會使會員失去部份或全部的優惠或權益，請謹慎使用。
        我們會保留您在連線至平台網站瀏覽或透過登錄APP時，伺服器自行產生的相關記錄，包括您使用連線設備的設備類型、
        IP 位址、使用時間、使用的瀏覽器、瀏覽及點選資料紀錄等。
      </p>
      <p>
        愛接送平台可能會使用網站或電子郵件中的beacon計算使用人次，為相關網站進行資料搜集工作，有關資料也會作統計用途。網站beacon所記錄的會員資料會整合起來，以綜合數據形式供合作伙伴參考。綜合數據會包括人數統計和使用情況等資料，除取得會員的同意之外，將不會包含任何可以識別個人身分的資料。如果會員不想參與資料搜集工作，可隨時通知愛接送平台。
      </p>
      <p>
        隨著營運模式的調整與改變，愛接送平台將會不時修訂網站政策，在使用個人資料的規定上作出大修改時，會在網頁上張貼告示，通知相關事項。
      </p>
    </section>
    <section>
      <h3>問題和建議</h3>
      <p>
        如果您有任何問題或建議，請透過客服信箱hantek-iot@hantek.com.tw或透過<a
          href="https://lin.ee/qq7E0q1"
          >Line@官方帳號</a
        >與我們聯繫。
      </p>
    </section>
    <p>生效日期：2021年09月</p>
  </div>
</template>

<style lang="scss">
section {
  margin-bottom: 35px;
}
</style>
